import { memo } from 'react';
import ZeroFeesTag from 'src/components/Tags/ZeroFeesTag';
import MarketLeverageTag from 'src/components/Utils/MarketLeverageTag';
import { cj } from 'src/utils/classNames';
import { MarketType } from '@velocity-exchange/sdk';

interface Props {
	marketName: string;
	marketIndex: number;
	isPerp: boolean;
	isMobileScreenSize: boolean;
	currentMarketIsPerp: boolean;
}

function MarketSelectorTableMarketNameCell({
	marketName,
	marketIndex,
	isPerp,
	isMobileScreenSize,
	currentMarketIsPerp,
}: Props) {
	return (
		<div className="flex flex-col gap-y-xs">
			<span
				className={cj(
					'typo-body-xs whitespace-nowrap text-text-default md:typo-label-xs',
					'font-semibold'
				)}
			>
				{isMobileScreenSize && !currentMarketIsPerp
					? marketName.replace('/USDC', '')
					: marketName}
			</span>

			<div className="flex gap-x-xs">
				<MarketLeverageTag
					marketType={isPerp ? MarketType.PERP : MarketType.SPOT}
					marketIndex={marketIndex}
				/>

				<ZeroFeesTag
					marketIndex={marketIndex}
					isPerp={isPerp}
					className="py-0.5"
				/>
			</div>
		</div>
	);
}

export default memo(MarketSelectorTableMarketNameCell);
